<template>
    <div class="category--dropdown">
        <div class="select-holder">
            <select v-on:change="changeValue($event.target.value)">
                <option v-for="(item, index) in dataList" :key="index" :value="item['id']" :selected="item['selected']" v-html="item['name']"> </option>
            </select>
            <svg width="15px" height="10px" viewBox="0 0 15 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Arkiv-aktuelt" transform="translate(-704.000000, -283.000000)" fill="#343638">
                        <g id="Filter-employee" transform="translate(540.000000, 260.000000)">
                            <g id="Icon:-Arrow" transform="translate(171.500000, 27.705882) rotate(270.000000) translate(-171.500000, -27.705882) translate(166.500000, 20.205882)">
                                <polygon id="Shape" points="9.16523618 2.078075 7.51817735 0.431016176 0.459353824 7.48983971 7.51817735 14.5486632 9.16523618 12.9016044 3.75347147 7.48983971"></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>

    </div>
</template>


<script>
export default {
    name: 'catlist',
    props: ['dataList'],
    data(){
        return {
            selected: null,
            thing : null,
        };
    },
    methods: {
        changeValue( value ){
            this.selected = value;
            this.$emit('update:selection', parseInt(this.selected));
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/js/vue/components/categoryList.vue?64210317